/**
 * User permission constants
 */
export enum UserPermission {
    Partner_SearchCustomers = 'Partner_SearchCustomers',
    Partner_ViewVouchers = 'Partner_ViewVouchers',
    Partner_ViewReport = 'Partner_ViewReport',
    Partner_ViewInvoice = 'Partner_ViewInvoice',
    Partner_OutletViewReport = 'Partner_OutletViewReport',
    Partner_OutletViewInvoice = 'Partner_OutletViewInvoice',
    Partner_ViewVouchersOutlet = 'Partner_ViewVouchersOutlet',
    Partner_ViewInvoices = 'Partner_ViewInvoices',
    PartnerAdmin_Permissions = 'PartnerAdmin_Permissions'
}

/**
 * Type for user permissions array
 */
export type UserPermissions = string[];
